import { useTinyHost } from "@tiny/host-contract";
import React from "react";
import { Typography } from "..";
import { EmptyStateProps } from "./EmptyState.types";
import { useStyles } from "./EmptyState.styles";
import Link from "../Link";

function EmptyState(props: EmptyStateProps) {
  const { navigate } = useTinyHost();
  const { children, title, message, icon, link, linkTo, linkId } = props;

  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <div className={classes.icon}>{icon}</div>
      <div className={classes.content}>
        <Typography
          className={classes.title}
          variant="h3"
          fontWeight="semiBold"
          color="grey"
          tone={900}
          mt={4}
          mb={1}
        >
          {title}
        </Typography>
        <Typography
          className={classes.message}
          variant="body2"
          component="p"
          color="grey"
          tone={700}
          m={0}
        >
          {message}
          {link && (
            <Link
              component={"button" as React.ElementType}
              onClick={() => navigate.to(String(linkTo))}
              id={linkId}
            >
              {link}
            </Link>
          )}
          {"."}
        </Typography>
      </div>
      {children && <div className={classes.extra}>{children}</div>}
    </div>
  );
}

export default EmptyState;
